import type { JSX } from "react";
import { useRef } from "react";

import { Dialog as BaseDialog } from "@base-ui/react/dialog";

import { DialogAnimationContext } from "./Dialog.context";
import type { DialogProps } from "./Dialog.types";

export function Dialog({
  originRef: originRefProp,
  ...props
}: DialogProps): JSX.Element {
  const internalOriginRef = useRef<DOMRect | null>(null);
  const originRef = originRefProp ?? internalOriginRef;

  return (
    <DialogAnimationContext.Provider value={originRef}>
      <BaseDialog.Root data-slot="dialog" {...props} />
    </DialogAnimationContext.Provider>
  );
}
